import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import {
  pdfTableBoldTextStyle,
  pdfTableCellTextStyle,
  pdfTableStyles
} from 'app/views/forms/pdf-components/PdfTableStyles'
import { myI18n } from 'translation/I18nConnectedProvider'

export const FormProjectAffiliationsFillablePDF = ({
  typeProps = {},
  title,
  value = [],
  langVersion,
  ...props
}) => {
  const { roles } = typeProps
  const currentLanguage = myI18n.language
  const referenceRoles = roles.some((obj) => obj.askForRelationship)
  const columns = referenceRoles ? 6 : 5
  const styles = {
    ...pdfTableStyles,
    tableCell: pdfTableCellTextStyle,
    mainTableCell: pdfTableBoldTextStyle,
    ...StyleSheet.create({
      equalColumn: {
        width: 75 / columns + '%'
      }
    })
  }

  const roleToTrans = {}
  roles.forEach((role) => {
    if (role?.apiValue && role?.label) {
      roleToTrans[role.apiValue] = role?.label?.portalTranslationId
        ? myI18n._(role.label.portalTranslationId)
        : role?.label?.[currentLanguage]
    }
  })

  return (
    <View>
      <View style={styles.table}>
        <View style={styles.tableRow} wrap={false}>
          <View style={[styles.tableCol, { width: '25%' }]}>
            <Text style={styles.mainTableCell}>{i18n._(t`Contact role`)}</Text>
          </View>
          <View style={[styles.tableCol, styles.equalColumn]}>
            <Text style={styles.mainTableCell}>{i18n._(t`First Name`)}</Text>
          </View>
          <View style={[styles.tableCol, styles.equalColumn]}>
            <Text style={styles.mainTableCell}>{i18n._(t`Last Name`)}</Text>
          </View>

          {!referenceRoles ? (
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.mainTableCell}>{i18n._(t`Job title`)}</Text>
            </View>
          ) : (
            <>
              <View style={[styles.tableCol, styles.equalColumn]}>
                <Text style={styles.mainTableCell}>{i18n._(t`Relationship to provider`)}</Text>
              </View>
              <View style={[styles.tableCol, styles.equalColumn]}>
                <Text style={styles.mainTableCell}>{i18n._(t`Organization`)}</Text>
              </View>
            </>
          )}

          <View style={[styles.tableCol, styles.equalColumn]}>
            <Text style={styles.mainTableCell}>{i18n._(t`E-mail`)}</Text>
          </View>
          <View style={[styles.tableCol, styles.equalColumn]}>
            <Text style={styles.mainTableCell}>{i18n._(t`Phone`)}</Text>
          </View>
        </View>

        {roles.map((role, index) => (
          <View style={styles.tableRow} key={index} wrap={false}>
            <View style={[styles.tableCol, { width: '25%' }]}>
              <Text style={styles.tableCell}>{!referenceRoles ? role.label[langVersion] : ''}</Text>
            </View>
            {referenceRoles && (
              <View style={[styles.tableCol, styles.equalColumn]}>
                <Text style={styles.tableCell} />
              </View>
            )}
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.tableCell} />
            </View>
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.tableCell} />
            </View>
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.tableCell} />
            </View>
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.tableCell} />
            </View>
            <View style={[styles.tableCol, styles.equalColumn]}>
              <Text style={styles.tableCell} />
            </View>
          </View>
        ))}
      </View>
    </View>
  )
}
